"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAV_OPEN = exports.CLASS_MODAL_OPEN = exports.CLASS_STICKY = exports.CLASS_ACTIVE = void 0;
exports.CLASS_ACTIVE = 'is-active';
exports.CLASS_STICKY = 'is-sticky';
exports.CLASS_MODAL_OPEN = 'is-modal-open';
exports.NAV_OPEN = 'nav-open';
